// Safe localStorage wrapper to handle Safari Incognito mode errors
export const safeLocalStorage = {
  getItem: (key: string, defaultReturnValue: unknown): string | null => {
    try {
      return window.localStorage.getItem(key)
    } catch {
      return defaultReturnValue ? String(defaultReturnValue) : null
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      window.localStorage.setItem(key, value)
    } catch {
      // Fail silently
    }
  },
  removeItem: (key: string): void => {
    try {
      window.localStorage.removeItem(key)
    } catch {
      // Fail silently
    }
  },
}
